import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { AdUnitForTableDTO } from 'features/inventory/ad-unit/components/AdUnitsTable/types/api'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const AD_UNIT_FOR_TABLE_FRAGMENT: TypedDocumentNode<AdUnitForTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitForTableFragment on AdUnit {
    divId
    domain {
      id
      alerts {
        ...AlertFragment
      }
      name
    }
    fieldAlerts {
      ...AlertFragment
    }
    id
    name
    outOfPage
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
